/** Reads a dotted/bracket property path from an object (e.g. `layers[0].texturePath`). */
export function readByPath(source: unknown, propertyPath: string): unknown {
  if (!source || !propertyPath) return undefined;
  const pathParts = propertyPath.replace(/\[(\d+)\]/g, '.$1').split('.').filter(Boolean);

  let current: unknown = source;
  for (const part of pathParts) {
    if (current == null || typeof current !== 'object') {
      return undefined;
    }
    current = (current as Record<string, unknown>)[part];
  }

  return current;
}
